import { keyframes } from '@emotion/react';
import { css, extractColor, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { generateTransitionStyles } from 'utils/style';
import { JobBoardIconSize, JobBoardIconStyleStates } from './types';

export const jobBoardIconSizes: Record<JobBoardIconSize, number> = {
  small: 24,
  medium: 30,
  big: 40,
};

const isActivatingAnimation = keyframes`
  from {
    transform: rotateZ(0deg) scale(1);
  }
  50% {
    transform: rotateZ(180deg) scale(0.8);
  }
  to {
    transform: rotateZ(360deg) scale(1);
  }
`;

const styles = {
  wrapper: ({ theme, props: { size, pointer } }) =>
    css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: jobBoardIconSizes[size],
      height: jobBoardIconSizes[size],
      backgroundColor: theme.colors.neutral.variant[0],
      borderRadius: '50%',
      overflow: 'hidden',
      boxSizing: 'content-box',
      ...(pointer && { cursor: 'pointer' }),
    }),
  content: ({ theme, props: { size, inactive, isActivating, backgroundColor } }) =>
    css({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: jobBoardIconSizes[size],
      height: jobBoardIconSizes[size],
      borderRadius: '50%',
      transition: generateTransitionStyles('opacity', (d) => d.long),
      color: theme.colors.primary.fuchsia[50],
      backgroundColor: theme.colors.primary.fuchsia[20],
      '&:hover': {
        backgroundColor: inactive ? theme.colors.neutral.variant[50] : theme.colors.primary.fuchsia[30],
        color: inactive ? theme.colors.neutral.variant[0] : theme.colors.primary.fuchsia[60],
      },
      ...(backgroundColor && {
        backgroundColor: extractColor(backgroundColor),
      }),
      ...(inactive && {
        color: theme.colors.neutral.variant[0],
        backgroundColor: theme.colors.neutral.variant[30],
      }),
      ...(isActivating && {
        animationName: isActivatingAnimation,
        animationDuration: '1000ms',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
      }),
    }),
} satisfies Styles<JobBoardIconStyleStates>;

export const useStyles = withStyles(styles);
